import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import App from './App';
import { PublicRoutes } from './pages/PublicRoutes';
import { AdminAuth } from './pages/AdminAuth';
import { NotificationProvider } from './shared/NotificatonContext';

const AppWrapper = () => {
    const [adminLogin, setAdminLogin] = useState(false);
    let location = useLocation();

    const AlterAdminAuth = () => {
        setAdminLogin(prev => prev = false);
        sessionStorage.removeItem('adminAuth');
    }

    useEffect(() => {
        const adminAuth = sessionStorage.getItem('adminAuth') !== undefined ? sessionStorage.getItem('adminAuth') : null;
        if (adminAuth !== null) {
            const adminAuthData = JSON.parse(sessionStorage.getItem('adminAuth') || "");
            if (adminAuthData.isAdminAuth === true) {
                setAdminLogin(true);
            };
        }
        window.scrollTo(0, 0);
    }, [location]);

    const auth = sessionStorage.getItem('auth') !== undefined ? sessionStorage.getItem('auth') : null;

    useEffect(() => {
        const originalFetch = window.fetch;

        window.fetch = async (input: any, init = {}) => {
            const url = typeof input === "string" ? input : input.url;

            const headers = new Headers(init.headers);

            // if (!url.toLowerCase().includes("/login")) {
            const systemId = JSON.parse(localStorage.getItem("systemAuth") + '');

            console.log(systemId);

            if (systemId) {
                headers.set("X-System-ID", systemId.System_ID);
            }
            // }

            return originalFetch(input, {
                ...init,
                headers
            });
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return (
        adminLogin === true ? <AdminAuth AlterAdminAuth={AlterAdminAuth} /> :
            (auth !== null ?
                <NotificationProvider>
                    <App />
                </NotificationProvider>
                : <PublicRoutes />)
    );
};

export default AppWrapper;
